// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__1X7dK","header":"ClearentDisclaimer_header__2LaD2","inner":"ClearentDisclaimer_inner__2Dq2q"};